import Skeleton from 'react-loading-skeleton';
import { InlineCardSkeleton } from '~/components/ListingCard';
import { useBreakpoint } from '~/hooks';

export default function RelatedListingsLoader() {
  const { mobileScreen } = useBreakpoint();
  return (
    <div className="flex flex-col gap-3x ">
      <div className="flex justify-between items-center">
        <Skeleton width={150} height={24} containerClassName="leading-none" />
        <Skeleton width={80} height={24} containerClassName="leading-none" />
      </div>
      <div className="relative related-listings-slider">
        {mobileScreen ? (
          <InlineCardSkeleton height={132} />
        ) : (
          <div className="flex gap-3x w-full">
            {Array(3)
              .fill(0)
              .map((_, index) => (
                <InlineCardSkeleton key={index} height={118} />
              ))}
          </div>
        )}
      </div>
    </div>
  );
}
